<template>
  <div class="flex column height100" v-if="!loading">
    <div class="flex xs12">
      <!-- Desktop sidebar (in flow) -->
      <TransitionExpandX v-if="screenWidth > 600" :width="sideBarWidth + 'px'">
        <SideBar
          v-if="user && !$route.meta.hideSideBar"
          :value="true"
          :width="sideBarWidth"
        />
      </TransitionExpandX>

      <div class="xs12" :class="{
        'xs12 ma-3 router-wrap' : !$route.meta.disableOuterBorder,
      }" style="transition: all 0.5s ease">
        <div class="menu-button" v-if="screenWidth <= 600">
          <Button :class="mobileMenuOpen ? 'primary' : 'glass-light-1'" @click="mobileMenuOpen = !mobileMenuOpen" variant="round">
            <i class="icofont-navigation-menu"></i>
          </Button>
        </div>
        <router-view v-slot="{ Component, route }">
          <Transition :name="route.meta.disableOuterBorder ? '' : 'page'" mode="out-in">
            <component :is="Component" :key="route.path" style="overflow: auto; width: 100%; height: 100%" />
          </Transition>
        </router-view>
      </div>

      <!-- Mobile sidebar (fixed overlay drawer) -->
      <Transition name="mobile-sidebar">
        <div
          v-if="mobileMenuOpen && screenWidth <= 600 && user && !$route.meta.hideSideBar"
          class="mobile-drawer"
        >
          <SideBar :value="true" :width="sideBarWidth" />
        </div>
      </Transition>
    </div>
  </div>
</template>

<script>
  import SideBar from './components/modules/SideBar.vue'
  import TransitionExpandX from './components/transitions/TransitionExpandX.vue'
  import Button from './components/common/Button.vue'
  import './assets/structure.css'
  import './assets/fonts/icofont/icofont.min.css'
  import 'floating-vue/dist/style.css'

  export default {
    name: 'App',
    components: {
      SideBar,
      TransitionExpandX,
      Button
    },
    data: () => ({
      sideBarWidth: 240,
      loading: true,
      mobileMenuOpen: false,
    }),
    async mounted() {
      window.addEventListener('resize', this.onWindowResize)
      this.onWindowResize()
      try {
        await this.$store.dispatch('init')
      } catch (err) {
        this.$router.push('signIn')
      }

      this.loading = false
    },
    unmounted() {
      window.removeEventListener('resize', this.onWindowResize)
    },
    watch: {
      $route() {
        this.mobileMenuOpen = false
      }
    },
    computed: {
      screenWidth() {
        return this.$store.getters.screenWidth
      },
      user() {
        return this.$store.getters.user
      }
    },
    methods: {
      onWindowResize() {
        this.$store.dispatch('set', {
          screenWidth: window.innerWidth,
          screenHeight: window.innerHeight
        })
      }
    }
  }
</script>

<style scoped>
  .menu-button {
    position: absolute;
    top: 8px;
    left: 8px;
    z-index: 1;
  }

  .mobile-drawer {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    overflow-y: auto;
    z-index: 100;
    background: rgb(234, 232, 229);
    box-shadow: 4px 0 20px rgba(0, 0, 0, 0.15);
  }

  .mobile-sidebar-enter-active,
  .mobile-sidebar-leave-active {
    transition: transform 0.3s ease;
  }
  .mobile-sidebar-enter-from,
  .mobile-sidebar-leave-to {
    transform: translateX(-100%);
  }
</style>

<style>
  /* cyrillic-ext */
  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    src: url(https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Mu72xKKTU1Kvnz.woff2)
      format('woff2');
    unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F,
      U+FE2E-FE2F;
  }
  /* cyrillic */
  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    src: url(https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Mu5mxKKTU1Kvnz.woff2)
      format('woff2');
    unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
  }
  /* greek-ext */
  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    src: url(https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Mu7mxKKTU1Kvnz.woff2)
      format('woff2');
    unicode-range: U+1F00-1FFF;
  }
  /* greek */
  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    src: url(https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Mu4WxKKTU1Kvnz.woff2)
      format('woff2');
    unicode-range: U+0370-03FF;
  }
  /* vietnamese */
  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    src: url(https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Mu7WxKKTU1Kvnz.woff2)
      format('woff2');
    unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169,
      U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323,
      U+0329, U+1EA0-1EF9, U+20AB;
  }
  /* latin-ext */
  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    src: url(https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Mu7GxKKTU1Kvnz.woff2)
      format('woff2');
    unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF,
      U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
  }
  /* latin */
  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    src: url(https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Mu4mxKKTU1Kg.woff2)
      format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
      U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122,
      U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
  @font-face {
    font-family: Aldrich Regular;
    src: url(./assets/fonts/Aldrich-Regular.ttf);
  }

  :root {
    /* Brand */
    --primary:          #3D6A90;
    --primary-dark:     #2d5475;
    --primary-muted:    rgba(61, 106, 144, 0.1);
    /* App UI */
    --app-border:       rgba(0, 0, 0, 0.1);
    --app-bg-input:     rgba(0, 0, 0, 0.04);
    --app-bg-hover:     rgba(0, 0, 0, 0.06);
    --app-bg-card:      #fff;
    --app-text:         rgba(0, 0, 0, 0.8);
    --app-text-muted:   rgba(0, 0, 0, 0.45);
    --app-transition:   0.15s ease;
    --app-radius-sm:    6px;
    --app-radius-md:    8px;
    --app-radius-lg:    12px;
  }

  html,
  body,
  #app {
    margin: 0;
    height: 100%;
    background-color: rgb(234, 232, 229);
  }
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .router-wrap {
    border-radius: 10px;
    overflow: hidden;
    background-color: #faf9f7;
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.12);
    position: relative;
  }
  .glassButton {
    max-height: 42px;
    height: 42px;
    background-color: rgba(255, 255, 255, 0.04);
    cursor: pointer;
    transition: background-color 0.2s ease;
  }
  .glassButtonActive {
    background-color: rgba(255, 255, 255, 0.15);
  }
  .glassButton:hover {
    background-color: rgba(255, 255, 255, 0.25);
  }
  .glass-dark-1 {
    background: rgba(0, 0, 0, 0.3);
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    border: 1px solid rgba(0, 0, 0, 0.15);
  }
  .glass-light-1 {
    background: rgba(255, 255, 255, 0.3);
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    border: 1px solid rgba(0, 0, 0, 0.1);
  }
  .glass-light-2 {
    background: rgba(255, 255, 255, 0.6);
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    border: 1px solid rgba(0, 0, 0, 0.1);
  }
  .glass-light-3 {
    background: rgba(255, 255, 255, 0.85);
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    border: 1px solid rgba(0, 0, 0, 0.1);
  }
  .glass-light-3-hover:hover {
    background: rgba(255, 255, 255, 0.95);
  }
  .glass-panel {
    border: 1px solid rgba(0, 0, 0, 0.3);
    background-color: rgba(255, 255, 255, 0.5);
    border-radius: 6px;
  }
  .primary-text {
    color: #3D6A90 !important;
  }
  .success-text {
    color: rgb(0, 129, 13) !important;
  }
  .disabled-text,
  .disabled-text i {
    color: rgba(255, 255, 255, 0.1);
  }
  .error {
    background-color: #ba0618;
  }
  .error-text {
    color: #d50000;
  }
  .success-text {
    color: #2f844b !important;
  }
  .warning-text {
    color: #dd7a02 !important;
  }
  .white-text {
    color: #fff;
  }
  .primary {
    background-color: #3D6A90 !important;
  }
  .primary-glass {
    background-color: rgba(26, 89, 137, 0.08) !important;
  }
  .error {
    background-color: #d50000;
  }
  .success {
    background-color: #388e3c !important;
  }
  .warning {
    background-color: #fb8c00 !important;
  }
  .info {
    background-color: #5d9aec !important;
  }
  .draftTag {
    position: absolute;
    right: 1px;
    top: 1px;
    font-size: 11px;
  }
  select {
    font-size: 0.875rem;
    font-weight: 400;
    border-radius: var(--app-radius-md);
    padding: 8px 12px;
    border: 1px solid var(--app-border);
    background: var(--app-bg-input);
    transition: all var(--app-transition);
    outline: none;
    color: var(--app-text);
  }
  select:focus {
    border-color: rgba(61, 106, 144, 0.5);
  }
  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23131313%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E');
    background-repeat: no-repeat, repeat;
    background-position: right 16px top 50%, 0 0;
    background-size: 0.65em auto, 100%;
  }
  .button-i {
    color: rgba(0, 0, 0, 0.4);
    transition: all 0.15s ease;
    cursor: pointer;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .button-i.disabled {
    cursor: default !important;
  }
  .button-i:not(.disabled):hover {
    color: rgba(0, 0, 0, 1);
    text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);
  }
  .button-i.white-text {
    color: rgba(255, 255, 255, 0.4);
    transition: all 0.15s ease;
    cursor: pointer;
  }
  .button-i:not(.disabled).white-text:hover {
    color: rgba(255, 255, 255, 1);
    text-shadow: 1px 1px 4px rgba(255, 255, 255, 0.3);
  }
  .v-enter-active,
  .v-leave-active {
    transition: opacity 0.15s ease;
  }

  .v-enter-from,
  .v-leave-to {
    opacity: 0;
  }

  .page-enter-active {
    transition: opacity 0.2s ease, transform 0.2s ease;
  }
  .page-leave-active {
    transition: opacity 0.06s ease;
  }
  .page-enter-from {
    opacity: 0;
    transform: translateY(10px);
  }
  .page-leave-to {
    opacity: 0;
  }
  .v-popper__wrapper {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  ::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0);
    transition: all 0.3s ease;
  }

  ::-webkit-scrollbar-track:hover {
    background: rgba(0, 0, 0, 0.1);
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.4);
    border-radius: 3px;
  }
  .tab {
    color: rgba(0, 0, 0, 0.5);
    cursor: pointer;
    transition: all 0.15s ease;
    font-weight: bold;
  }
  .tab:hover {
    color: rgba(0, 0, 0, 0.75);
  }
  .tab-active {
    color: rgba(0, 0, 0, 0.85) !important;
  }
</style>
